import { ReactNode } from 'react';

export const TableHeadWrapper = ({
  children,
  ...props
}: {
  children: ReactNode;
}) => {
  return <thead {...props}>{children}</thead>;
};
